// https://developers.google.com/protocol-buffers/docs/encoding#structure
export const CODEC_TYPES = {
    VARINT: 0,
    BIT64: 1,
    LENGTH_DELIMITED: 2,
    START_GROUP: 3,
    END_GROUP: 4,
    BIT32: 5
};
export function createCodec(name, type, encode, decode, stream) {
    return {
        name,
        type,
        encode,
        decode,
        stream
    };
}
//# sourceMappingURL=codec.js.map